/* app/js/src/components/content-control/studio/content-control-studio/content-control-studio-dropdown/content-control-studio-dropdown.component.scss */
.cursor-pointer {
  cursor: pointer;
}
ul::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
ul::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
ul::-webkit-scrollbar-corner {
  background: transparent;
}
ul::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
ul::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
ul::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
ul::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
ul::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
:host {
  background: rgb(255, 255, 255);
  border-radius: 3.74px;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.35);
  border-width: 0.94px;
  padding: 5.61px 5.61px 5.61px 8px;
  display: flex;
  gap: 4px;
  position: relative;
}
.select {
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  justify-content: flex-start;
  flex-shrink: 0;
  position: relative;
}
.select.action {
  cursor: pointer;
}
.select .selected {
  display: flex;
  gap: 4px;
}
.select .selected ::ng-deep .icon {
  -webkit-user-select: none;
  user-select: none;
  background: rgba(0, 0, 0, 0.35);
  border-radius: 2px;
  padding: 3px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.select .selected ::ng-deep .text {
  -webkit-user-select: none;
  user-select: none;
  flex-grow: 1;
  color: rgba(0, 0, 0, 0.35);
  text-align: center;
  font-family: "OpenSans-Bold", sans-serif;
  font-size: 12px;
  line-height: 17px;
  font-weight: 700;
  text-transform: uppercase;
  position: relative;
}
.select .caret {
  transition: 0.3s;
}
.select .caret-rotate {
  transform: rotate(180deg);
}
ul {
  -webkit-user-select: none;
  user-select: none;
  list-style: none;
  padding: 0.2em 0.5em;
  background: rgb(235, 240, 244);
  border: 1px rgb(194, 204, 219) solid;
  box-shadow: 0px 1px 15px 0px rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  color: rgba(0, 0, 0, 0.35);
  position: absolute;
  display: flex;
  flex-direction: column;
  gap: 5px;
  top: 20px;
  left: 50%;
  width: 100%;
  height: 135px;
  overflow-y: auto;
  overflow-x: hidden;
  transform: translateX(-50%);
  opacity: 0;
  display: none;
  transition: 0.2s;
  z-index: 10;
}
ul.menu-open {
  display: flex;
  opacity: 1;
}
ul li {
  padding: 0.7em 0.5em;
  border-radius: 0.5em;
  line-height: 17px;
  text-transform: uppercase;
  cursor: pointer;
}
ul li:hover {
  background: rgba(0, 0, 0, 0.04);
}
ul li.active {
  background: rgba(0, 0, 0, 0.08);
}
/*# sourceMappingURL=content-control-studio-dropdown.component.css.map */
